import React, { useState } from 'react';
import styled from 'styled-components';

import { ContentContainer } from '@/modules/CarModelLanding/common.styles';
import { useCarModelLandingData } from '@/modules/CarModelLanding/hooks';
import {
  CarConfigurationSlider,
  ColorPicker,
  Description,
  FeatureListSecondary,
  Tabs,
  Title,
} from '@/components/CarModelLandingWidgets';
import { ColorPickerOnChangeConfig } from '@/components/CarModelLandingWidgets/ColorPicker/types';

function ModelConfiguration() {
  const {
    configurationTitle,
    configurationGallery,
    configurationText,
    configurationItems,
  } = useCarModelLandingData();

  const complectationTabs =
    configurationGallery && configurationGallery.length !== 0
      ? configurationGallery.map(({ complectation }, index) => ({
          label: complectation ?? '',
          value: index,
        }))
      : [];
  const hasTabs = complectationTabs.length !== 0;

  const [activeComplectationTab, setActiveComplectationTab] = useState<number>(
    hasTabs ? complectationTabs[0].value : 0
  );

  const colors =
    configurationGallery && configurationGallery.length !== 0
      ? configurationGallery[activeComplectationTab]?.complectationItems.map(
          (item) => ({ color: item.color ?? '' })
        )
      : [];

  const [activeComplectationColor, setActiveComplectationColor] =
    useState<ColorPickerOnChangeConfig>({
      activeColorIndex: 0,
      activeColor: colors[0]?.color ?? '',
    });

  const sliderImages =
    configurationGallery && configurationGallery.length !== 0
      ? configurationGallery[activeComplectationTab]?.complectationItems[
          activeComplectationColor.activeColorIndex
        ]?.images
      : [];

  if (
    !configurationTitle &&
    !hasTabs &&
    sliderImages?.length === 0 &&
    colors?.length === 0 &&
    !configurationText &&
    configurationItems?.length === 0
  ) {
    return null;
  }

  return (
    <Component id="configuration">
      <ContentContainer>
        {configurationTitle && <Title title={configurationTitle} />}

        {hasTabs && (
          <TabsWrapper>
            <Tabs
              data={complectationTabs}
              activeValue={activeComplectationTab}
              onChange={(value) => {
                setActiveComplectationTab(value);
                setActiveComplectationColor({
                  activeColorIndex: 0,
                  activeColor: colors[0]?.color ?? '',
                });
              }}
              isBlock
            />
          </TabsWrapper>
        )}

        {sliderImages && sliderImages.length !== 0 && (
          <SliderWrapper>
            <CarConfigurationSlider images={sliderImages} />
          </SliderWrapper>
        )}

        {colors && colors.length !== 0 && (
          <ColorPickerWrapper>
            <ColorPicker
              colors={colors}
              activeColor={activeComplectationColor.activeColor}
              onChange={setActiveComplectationColor}
            />
          </ColorPickerWrapper>
        )}

        {configurationText && (
          <DescriptionWrapper>
            <Description description={configurationText} />
          </DescriptionWrapper>
        )}

        {configurationItems && configurationItems.length !== 0 && (
          <FeatureListWrapper>
            <FeatureListSecondary
              features={configurationItems.map(
                ({ image, title, description }) => ({
                  image,
                  title: title ?? '',
                  text: description ?? '',
                })
              )}
            />
          </FeatureListWrapper>
        )}
      </ContentContainer>
    </Component>
  );
}

export default ModelConfiguration;

const Component = styled.section`
  padding: 30px 0;
`;

const TabsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;

const SliderWrapper = styled.div`
  margin-top: 30px;
`;

const ColorPickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

const DescriptionWrapper = styled.div`
  margin-top: 40px;
`;

const FeatureListWrapper = styled.div`
  margin-top: 60px;
`;
